import { t } from '@avalara/bat-apps-shared/i18n';
import { SIcon } from '@avalara/skylab-sdk/react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useAppDispatch } from '../../../../hooks/use-app-dispatch';
import { completePlanSelect } from '../../../../lib/side-effects/offer-flow';
import { offerStateSelector } from '../../../../selectors/offer';

type Props = {
  selectedPlanName: string | null;
  disableButton?: boolean;
};

const NextButton = ({ selectedPlanName, disableButton }: Props) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { offerFlow, plans } = useSelector(offerStateSelector);
  const selectedPlan = plans.find((plan) => plan.name === selectedPlanName);
  return (
    <button
      type='button'
      className='primary icon-trailing'
      disabled={!selectedPlanName || disableButton}
      onClick={selectedPlan ? () => dispatch(completePlanSelect(selectedPlan, { history })) : undefined}
      data-ref={offerFlow ? `${offerFlow}.plan-select-button` : ''}
    >
      {t('client.buttons.next')}
      <SIcon name='arrow-circle-right' />
    </button>
  );
};
export default NextButton;
